import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const DownloadIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M32 9.87256c1.1782 0 2.1333.95514 2.1333 2.13334v29.8667c0 1.1782-.9551 2.1333-2.1333 2.1333-1.1782 0-2.1333-.9551-2.1333-2.1333V12.0059c0-1.1782.9551-2.13334 2.1333-2.13334z"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M64 52.5392c0 1.1782-.9551 2.1334-2.1333 2.1334H2.13333C.95513 54.6726 0 53.7174 0 52.5392s.95513-2.1333 2.13333-2.1333H61.8667c1.1782 0 2.1333.9551 2.1333 2.1333z"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M15.5582 25.4307c.8331-.8331 2.1838-.8331 3.017 0L32 38.8556l13.4248-13.4249c.8332-.8331 2.1839-.8331 3.017 0 .8332.8331.8332 2.1839 0 3.017L33.5085 43.3811c-.8331.8331-2.1839.8331-3.017 0L15.5582 28.4477c-.8331-.8331-.8331-2.1839 0-3.017z"
    />
  </IconBox>
);

export default DownloadIcon;
